var boxSelection = 0;
var boxSize = 4;
var boxPrice = 25;
var boxName = '';
let cookiesInCart = [];

var cookies = [];
var boxVariations = [];
var giftTypes = "Plain Card,Congrats!,Happy Birthday!,You're the Sweetest,Thank You,Happy Anniversary!,Happy Thanksgiving!";

var number = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty', 'Twenty-One', 'Twenty-Two', 'Twenty-Three', 'Twenty-Four', 'Twenty-Five', 'Twenty-Six', 'Twenty-Seven', 'Twenty-Eight', 'Twenty-Nine', 'Thirty', 'Thirty-One', 'Thirty-Two'];

function createCookie(name, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

function buildQuery(params) {
    const query = new URLSearchParams();

    for (const key in params || {}) {
        if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
        if (params[key] === undefined || params[key] === null) continue;
        query.set(key, params[key]);
    }

    return query.toString();
}

function buildArchieUrl(path, params) {
    const query = buildQuery(params);
    return `/apps/archie${path}${query ? `?${query}` : ""}`;
}

function call(path, params = {}, options) {
    return fetch(buildArchieUrl(path, params), options);
}

async function callArchieJson(path, params = {}, options = {}) {
    const attempts = options.attempts || 2;
    const timeoutMs = options.timeoutMs || 8000;

    for (let attempt = 1; attempt <= attempts; attempt += 1) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), timeoutMs);

        try {
            const response = await call(path, params, { signal: controller.signal });

            if (!response.ok) {
                throw new Error(`Archie II request failed with status ${response.status}`);
            }

            const data = await response.json();

            if (!Array.isArray(data.products) || !Array.isArray(data.boxes)) {
                throw new Error('Archie II returned an invalid builder response');
            }

            return data;
        } catch (error) {
            if (attempt === attempts) throw error;
            await new Promise((resolve) => setTimeout(resolve, 500));
        } finally {
            clearTimeout(timeout);
        }
    }
}

var productCache = null;
var onceLoaded = [];

function applyMetafieldsToProductForm() {
  const forms = document.querySelectorAll('form.pf-product-form, form.product-form-product-template');

  for (const form of forms) {
    const productID = form.children['product-id']?.value;

    if (typeof productID !== 'string') continue;

    if (product && product.id == productID) {
      injectFormData(form, product);
    } else {

      if (productCache === null) {
        fetchAllProducts();
      }

      if (productCache === null) {
        onceLoaded.push(getProductData.bind(this, form, productID));
      } else {
        getProductData(form, productID);
      }
    }
  }
}

async function fetchAllProducts() {
  const response = await fetch('https://yvrcookie.com/collections/all?view=archie-products');
  productCache = await response.json();

  for (const func of onceLoaded) {
    func();
  }
}

function getProductData(form, productID) {
  const product = productCache.find(item => item.id == productID);

  if (product == null) return;

  injectFormData(form, product);
}

function injectFormData(form, product) {
  const metafieldsToInject = [
    ['end_date', '_unavailableAt'],
    ['start_date', '_availableAt'],
  ];

  for (const [key, name] of metafieldsToInject) {
    const value = product.metafields[key];

    if (value === undefined) continue;

    const inputEl = document.createElement('input');
    inputEl.setAttribute('type', 'hidden');
    inputEl.setAttribute('name', `properties[${name}]`);
    inputEl.setAttribute('value', value);

    form.append(inputEl);
  }
}

document.addEventListener("DOMContentLoaded", applyMetafieldsToProductForm);
